import React from 'react'

function User() {
  return (
    <div><h1>User Logged In</h1></div>
  )
}

export default User